<template>
  <div class="policy-page">
    <h1>Disclaimer</h1>

    <p class="muted"><em>PathTracer — Important Notice & Limitations</em></p>

    <ol>
      <li>
        <strong>Open‑source & third‑party data.</strong>
        Reports are generated from publicly available blockchains, block explorers, and other third‑party/open‑source sources.
        These sources can be incomplete, inaccurate, or change without notice. PathTracer does not control these sources and
        cannot guarantee their content.
      </li>
      <li>
        <strong>Point‑in‑time snapshot.</strong>
        Each report reflects data available at the time it was produced. Subsequent blocks, chain reorganizations, amended labels,
        or API corrections may alter interpretations.
      </li>
      <li>
        <strong>No guarantee of completeness, accuracy, or timeliness.</strong>
        The report is provided on an <q>as is</q> and <q>as available</q> basis without warranties of any kind, express or implied.
      </li>
      <li>
        <strong>User responsibility.</strong>
        You are solely responsible for independently verifying the results, obtaining professional advice where appropriate, and
        determining how to use or interpret the report.
      </li>
      <li>
        <strong>No legal, financial, or accounting advice.</strong>
        PathTracer reports are technical analyses and are not a substitute for legal counsel, financial due diligence, or accounting review.
      </li>
      <li>
        <strong>Assumption of risk; limitation of liability.</strong>
        To the maximum extent permitted by law, PathTracer, its operators, and affiliates are not liable for any decisions, actions,
        losses, or damages (direct, indirect, incidental, consequential, or otherwise) arising from or related to use of a report.
      </li>
      <li>
        <strong>Jurisdiction & compliance.</strong>
        You represent that your use complies with all applicable laws and you have any necessary authorizations to analyze, process,
        or store the data involved.
      </li>
      <li>
        <strong>Use of the term “Report.”</strong>
        “Report” includes the narrative text, flags, icons, screenshots, diagrams, raw output, and any derived visualizations packaged
        with this modal or export.
      </li>
      <li>
        <strong>Updates.</strong>
        PathTracer may update its methods, datasets, and this disclaimer at any time.
      </li>
      <li>
        <strong>Contact.</strong>
        For questions about methodology or to report suspected data errors, contact the PathTracer team.
      </li>
    </ol>

    <p class="muted">© {{ year }} PathTracer. All rights reserved.</p>

    <router-link to="/" class="back-link">← Return to Home</router-link>
  </div>
</template>

<script>
export default {
  name: "DisclaimerPage",
  data() {
    return { year: new Date().getFullYear() };
  },
};
</script>

<style scoped>
.policy-page {
  max-width: 900px;
  margin: 0 auto;
  padding: 24px;
  line-height: 1.65;
}

h1 {
  margin-top: 0;
  color: #2c3e50;
}

ol {
  padding-left: 20px;
}

li {
  margin: 0 0 12px;
}

.muted {
  color: #6b7280;
}

.back-link {
  display: inline-block;
  margin-top: 28px;
  text-decoration: underline;
  color: #3498db;
}

.back-link:hover {
  color: #217dbb;
}
</style>
